import { IonToolbar, IonTitle } from "@ionic/react";
import React from "react";
import { useSelector } from "react-redux";
import { selectOrganization } from "../../../store/organizationShow/selectors/selectLocation";

export const HeaderSection: React.FC = () => {
  const organization = useSelector(selectOrganization);

  return (
    <IonToolbar>
      <IonTitle>{organization?.name}</IonTitle>
    </IonToolbar>
  );
};
